import { render } from "./PortariaOverviewPanel.vue?vue&type=template&id=d65d90d8&scoped=true&ts=true"
import script from "./PortariaOverviewPanel.vue?vue&type=script&lang=ts"
export * from "./PortariaOverviewPanel.vue?vue&type=script&lang=ts"

import "./PortariaOverviewPanel.vue?vue&type=style&index=0&id=d65d90d8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d65d90d8"]])

export default __exports__